export default { sha: '0756e6118b5de527c4d8c587d9599f640c939858', buildNumber: 'undefined' }
